import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import Text from 'components/Text/Text';
import { Badge } from 'components/Badge';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './ModifierGroupFromTemplate.module.scss';

interface IProps {
	onDelete: (id: string) => void;
	positionNumber: number;
	label: string;
	modifierGroupId: string;
	inclusive: Nullable<number>;
	isLimitsProtected: Nullable<boolean>;
	isAdditional: Nullable<boolean>;
	lowerLimit: Nullable<number>;
	upperLimit: Nullable<number>;
}

export const ModifierGroupFromTemplate: React.FC<IProps> = React.memo(
	({
		onDelete,
		positionNumber,
		label,
		modifierGroupId,
		inclusive,
		isLimitsProtected,
		isAdditional,
		lowerLimit,
		upperLimit,
	}) => {
		const handleRemove = () => {
			onDelete(modifierGroupId);
		};

		return (
			<div className={style.container}>
				<div className={style.header}>
					<div className={style.labelRow}>
						<Text
							className={style.positionNumber}
							translationNameSpace="form"
							translationKey="positionNumberLabel"
							translationOptions={{ positionNumber }}
							size="s"
							weight="bold"
						/>
						<Text className={style.labelText} translationKey={label} size="s" withTooltip={true} />
						<div />
					</div>
					<div className={style.itemAdditionalInfoDeleteBtnWrapper}>
						<div className={style.itemAdditionalInfo}>
							<Text
								translationNameSpace="form"
								translationKey="inclusiveLabel"
								theme="neutralLight"
								size="xs"
							/>
							<Text translationKey={typeof inclusive === 'number' ? String(inclusive) : '-'} size="xs" />
						</div>
						<Badge color="red">
							<Text
								translationNameSpace="form"
								translationKey="fromTemplateLabel"
								asFragment={true}
								data-test="modGroupFromTemplate"
							/>
						</Badge>
						<div className={style.deleteBtn} onClick={handleRemove}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#bin`} />
							</svg>
						</div>
					</div>
				</div>
				<div className={style.limits}>
					{isLimitsProtected && (
						<FullInfoField
							containerClassName={style.fullInfoFieldContainer}
							inputWrapperClassName={style.fullInfoFieldWrapper}
							className={style.fullInfoFieldInput}
							translationNameSpace="form"
							value="protectFromSyncLabel"
							prefixIcon="asCheckbox"
							prefixIconName="checkMark"
							prefixIconIsChecked={true}
							useInForm={true}
						/>
					)}
					{isAdditional && (
						<FullInfoField
							containerClassName={style.fullInfoFieldContainer}
							inputWrapperClassName={style.fullInfoFieldWrapper}
							className={style.fullInfoFieldInput}
							translationNameSpace="form"
							value="useAsAdditionalLabel"
							prefixIcon="asCheckbox"
							prefixIconName="checkMark"
							prefixIconIsChecked={true}
							useInForm={true}
						/>
					)}
					<div className={style.itemAdditionalInfo}>
						<Text
							translationNameSpace="form"
							translationKey="lowerLimitLabel"
							theme="neutralLight"
							size="xs"
						/>
						<Text translationKey={typeof lowerLimit === 'number' ? String(lowerLimit) : '-'} size="xs" />
					</div>
					<div className={style.itemAdditionalInfo}>
						<Text
							translationNameSpace="form"
							translationKey="upperLimitLabel"
							theme="neutralLight"
							size="xs"
						/>
						<Text translationKey={typeof upperLimit === 'number' ? String(upperLimit) : '-'} size="xs" />
					</div>
				</div>
			</div>
		);
	},
);
